import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[kwBlogSizer]'
})
export class BlogSizerDirective implements AfterViewInit {

  constructor(private el:ElementRef<HTMLElement>) { }
  
  ngAfterViewInit(): void {
    let host:HTMLElement = this.el.nativeElement.querySelector('.content');
    if(host != undefined){
      host.style.maxWidth = "960px";
      host.style.margin = "auto";
    }
  }

}
